import ProductGuidesContainer from './product-guides-container';

export default ProductGuidesContainer;